module.exports = __webpack_public_path__ + "img/6.4345a885.png";